import './random-link';

// 导入公共入口文件 (必须)
import main from '@/main.js';

//初始化公共vuex方法
import initGlobalData from '@/initGlobalData';
import store from './store';
import rootStore from '@/store';

// 路由页面 (必须)
import router from './router.js';

//神策,不用可注释
import Vue from 'vue';
import Sensors from '@/components/js/sensors'; //神策

import { XL_ACCOUNT_TYPE } from '@/utils/constants';
// 字体
import './assets/font/font.css';
// 分享方法
import shareMixin from './mixins/share';
Vue.use(shareMixin);
// 埋点方法
import visitlogMixin from './mixins/trackLog';
Vue.use(visitlogMixin);

//工具类
import { getUrlParam } from '@/utils';

// mock
// import mock from './mock/index';
// mock();

// 请求方法
import request from '@/axios/request';
Vue.use(request, router, rootStore);
import './assets/font/font.css';

// watch dog sendEvent
import { sendEvent } from '@/components/js/watchDog/custom';

// let blType = getUrlParam('bl');
let uType = getUrlParam('u');
let userType = uType === '1' ? 'user' : 'driver';
function checkIsXl() {
  let { host } = window.location;
  return /xiaolachuxing.com/.test(host);
}
//神策埋点
let sensorUsertype = checkIsXl() ? `xl${userType}` : userType; //  神策 埋点的项目名称
console.log(window.location.href, sensorUsertype, 'window.location.href----->');
console.log('merge xialachuxing.gitlab.cn====');
Vue.use(Sensors, sensorUsertype, store);

// 捕捉浏览器中未处理的Promise错误
window.addEventListener('unhandledrejection', event => {
  sendEvent('UN_HANDLED_REJECTION', event.reason, { ...event });
});
//初始化,设置活动的初始信息
let init = initGlobalData({
  env: userType,
  actName: 'multi_service_invite',
  accountType: checkIsXl() ? XL_ACCOUNT_TYPE : '',
  appToken: getUrlParam('token') || getUrlParam('_token'),
  uuid: getUrlParam('uuid'),
  ref: getUrlParam('ref'),
  version:
    getUrlParam('version') || getUrlParam('revision') || getUrlParam('app_ver')
});
// 传递一个要展示的页面组件给公共入口函数 (必须),第三个可选参数为store
main.init(router, init, store);
